import { CtWebapiGenericResponse, CtWebapiService, DataRequest } from "@ctsolution/ct-webapi";
import { Injectable } from "@angular/core";
import { BatchDTO } from "../classes/BatchDTO";
import { FbGeneralModalConfiguration } from "src/app/components/fb-general-modal/fb-general-modal.configuration";
import { Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BatchDraftDTO } from "../classes/BatchDraftDTO";




@Injectable()
export class BatchController {

    controller = '/Batch';
    dialogConfiguration = FbGeneralModalConfiguration.create("Asta creata")
    .setStringList([
        'Grazie per aver creato la tua asta!',
        'Grazie per aver scelto di utilizzare la nostra piattaforma.',
        'I dettagli della tua asta sono stati registrati e saranno disponibili per gli utenti a partire dalla data di disponibilità selezionata.'])
    .setLabelButton1('OK')
    .setClosable(false)
    .setAction(() => this.router.navigate(['/']));
    ref: DynamicDialogRef | undefined;

    constructor(
        private ctWebApiService : CtWebapiService,
        private dialogService: DialogService,
        private router: Router
    ) {}

    createUpdate(param: BatchDTO): Promise<any> {

        return new Promise<any>((resolve, reject) => {
            this.ctWebApiService
                .post(new DataRequest(`${this.controller}/CreateUpdate`, { hideSpinner: false}), param)
                .subscribe({
                    next: (res: CtWebapiGenericResponse<any>) => resolve(res.Result),
                    error: (err) => reject(err) // Per gestire eventuali errori
                });
        });
    }

    getBatchInfo(oid: number): Promise<BatchDTO> {
        return new Promise<BatchDTO>((resolve) => {
          this.ctWebApiService
            .get(new DataRequest(`${this.controller}/Get`, { oid,  hideSpinner: false}))
            .subscribe((res: CtWebapiGenericResponse<any>) => {
              if (res.Result) resolve(res.Result);
            });
        });
      }

      getBatchList(param: any | null){

        return new Promise<any>((resolve) => {

            this.ctWebApiService
            .post(new DataRequest(`${this.controller}/list`, { hideSpinner: false}), param)
            .subscribe((res: CtWebapiGenericResponse<any>) => {

                if(res.Result)
                    resolve(res.Result.Elements);
                else resolve([]);

            })

        });

    }

    getBatchDraft(){

        return new Promise<BatchDraftDTO | null>((resolve) => {

            this.ctWebApiService
            .get(new DataRequest(`${this.controller}/GetDraft`, { hideSpinner: false}))
            .subscribe((res: CtWebapiGenericResponse<any>) => {

                if(res.Result)
                    resolve(res.Result);
                else resolve(null);

            })

        });

    }

    delete(oid: number): Promise<any> {

        return new Promise<any>((resolve, reject) => {
            this.ctWebApiService
                .post(new DataRequest(`${this.controller}/Delete`, { oid, hideSpinner: false}))
                .subscribe({
                    next: (res: CtWebapiGenericResponse<any>) => resolve(res.Result),
                    error: (err) => reject(err) // Per gestire eventuali errori
                });
        });
    }

    suspend(param: BatchDTO): Promise<any> {

        return new Promise<any>((resolve, reject) => {
            this.ctWebApiService
                .post(new DataRequest(`${this.controller}/Suspend`, { hideSpinner: false}), param)
                .subscribe({
                    next: (res: CtWebapiGenericResponse<any>) => resolve(res.Result),
                    error: (err) => reject(err) // Per gestire eventuali errori
                });
        });
    }




}
